import config from '../../../config';

const PROVISION_QUALITY_URL_PATTER = /^\/dashboard\/provision-quality-single\/.+$/;

const getPathNameForHelpContent = () => {
  const regexpForBaseUrl = new RegExp(`^${config.BASE_PATH}`);
  const currentPathname = window.location.pathname.replace(regexpForBaseUrl, '');

  if (currentPathname === '/') {
    return '/dashboard';
  }
  if (PROVISION_QUALITY_URL_PATTER.test(currentPathname)) {
    return '/dashboard/provision-quality-single';
  }

  return currentPathname;
};

export default getPathNameForHelpContent;
